import React, { useEffect, useState } from 'react'
import {
  CAvatar,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import CIcon from '@coreui/icons-react';
import { cilCloudUpload } from '@coreui/icons';
import PencilIcon from '../icons/PencilIcon';
import TNC from '../icons/TermNConditions';
import LogOutIcon from '../icons/LogoutIcon';
import FNQIcon from '../icons/faqIcon';
import Home from '../icons/Home.svg';
import CustomerCareIcon from '../icons/CustomerCareIcon';
import avatar from '../../assets/images/avatars/user.jpg'
import { Link } from 'react-router-dom';
import Swal from "sweetalert2";
import { Profile, PhotoAPI } from '../../API/player';
import { FilterDynamicText } from '../../API/admin';

import { useSnackbar } from 'notistack'

import { enqueueSnackbar } from 'notistack'

const AppHeaderDropdown = () => {
  const [profile, setProfile] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
  const [dynamicHeading, setDynamicHeading] = useState({});

  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile();
      if (res.status) {
        console.log(res.data.profile_image);
        setProfile(res.data);
      }
    }

    let callAPIDynamictext = async () => {
      let formData = {
        "data": null
      }
      let res = await FilterDynamicText(formData);
      if (res.data.status) {
        console.log(res.data.data)
        setDynamicHeading(res.data.data)
      }
    }

    callAPI();
    callAPIDynamictext();
  }, [])

  let PhotoReq = async () => {
    console.log("Hello")
    Swal.fire({
      title: dynamicHeading.request_photo_video
        ? dynamicHeading.request_photo_video.title
        : "Request photo/video?",
      text: dynamicHeading.request_photo_video
        ? dynamicHeading.request_photo_video.value : "Request photo/video?",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send Request",
      cancelButtonText: "Close"

    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await PhotoAPI();
        if (res.data.status) {
          if (res.data.NoMatch) {
            enqueueSnackbar('You have not played any matches yet', {
              variant: 'error', action: (key) => (
                <button className='toast_close_btn'
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            })

          } else {

            enqueueSnackbar('Request was sent successfully', {
              variant: 'success', action: (key) => (
                <button className='toast_close_btn'
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            })

          }
        } else {
          enqueueSnackbar('Unable to send request at the moment', {
            variant: 'error', action: (key) => (
              <button className='toast_close_btn'
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          })
        }

      }
    });

  }
  return (
    <CDropdown variwant="nav-item" className='header-nav-dropdown'>
      <CDropdownToggle placement="bottom-end" className="py-0 pe-0 border-0" caret={false}>
        <div className='profile_header_userdash' style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          // backgroundImage: profile && profile.profile_image ?
          //   `url(${IMAGE_URL}user/${profile.profile_image})` :
          //   `url(${IMAGE_URL}/blank_user.png)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
          <img
            src={profile && profile.profile_image ? `${IMAGE_URL}user/${profile.profile_image}` : `${IMAGE_URL}/blank_user.png`}
            alt="Profile" style={{ height: "100%", width: "100%", borderRadius: "50%", objectFit: "cover" }}
          />
        </div>

        {/* <CAvatar src={profile != null ?IMAGE_URL+'user/'+profile.profile_image: null } shape={'rounded-pill'}  size="xl" /> */}
      </CDropdownToggle>
      <CDropdownMenu className="py-0 " placement="bottom-end">
        <Link to='/' className='text-decoration-none'>
          <CDropdownItem href="#" className='text-white py-2'>
            <img src={Home} style={{ height: '18px', width: '18px' }}></img>
            <span className='ps-2 '> Home </span>
          </CDropdownItem>
        </Link>
        <Link to='/participant/profile' className='text-decoration-none'>
          <CDropdownItem href="#" className='text-white py-2'>
            <PencilIcon />
            <span className='ps-2 '> My Profile </span>
          </CDropdownItem>
        </Link>

        {/* <CDropdownItem href="/terms&condition" className='text-white py-2'>
          <TNC />
          <span className='ps-2'> Terms & Conditions</span>
        </CDropdownItem>
        <CDropdownItem href="/privacy&policy" className='text-white py-2'>
          <TNC />
          <span className='ps-2'> Privacy & Policy</span>
        </CDropdownItem>

        <CDropdownItem href="/contact" className='text-white py-2'>
          <CustomerCareIcon />
          <span className='ps-2'> Help & Support</span>
        </CDropdownItem>

        <CDropdownItem href="/#faqs" className='text-white py-2'>
          <FNQIcon />
          <span className='ps-2'> FAQ</span>
        </CDropdownItem> */}

        {/* <Link to='/participant/feedback' className='text-decoration-none'>
          <CDropdownItem className='text-white py-2'>
            <FNQIcon />
            <span className='ps-2'> Feedback </span>
          </CDropdownItem>
        </Link> */}
        <CDropdownItem onClick={() => PhotoReq()} className='text-white py-2 d-flex' style={{ cursor: "pointer" }}>
          <CIcon icon={cilCloudUpload} size="lg" />
          <span className='ps-2' > Request Photo/Video</span>
        </CDropdownItem>

        <CDropdownItem href="/logout" className='text-white py-2'>
          <LogOutIcon />
          <span className='ps-2'> Logout</span>
        </CDropdownItem>

      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
